// Pre-owned deals (Sales & Offers) are sold fully upfront — no installment plans
export const PRE_OWNED_SALES_TYPE = 'pre-owned-deals';

// Products carry salesType; cart items carry their category as produtCategory
// (backend spelling)
export const isFullPaymentOnly = (product) =>
  product?.salesType === PRE_OWNED_SALES_TYPE ||
  product?.produtCategory?.slug === PRE_OWNED_SALES_TYPE ||
  product?.productCategory?.slug === PRE_OWNED_SALES_TYPE;

export const parsePaymentOptions = (raw) => {
  if (Array.isArray(raw)) return raw;
  try {
    const parsed = JSON.parse(raw || '[]');
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

// The product's payment options, restricted to the full-payment option for
// full-payment-only products (falling back to the product price if the backend
// didn't send a 'full' option)
export const getPaymentOptions = (product) => {
  const options = parsePaymentOptions(product?.paymentOptionsBreakdown);
  if (!isFullPaymentOnly(product)) return options;

  const fullOptions = options.filter(
    (opt) => String(opt?.type || '').toLowerCase() === 'full'
  );
  if (fullOptions.length > 0) return fullOptions;

  const price = Number(
    Number(product?.fairAppSalesPrice) > 0
      ? product.fairAppSalesPrice
      : product?.fairAppPrice || product?.productPrice || 0
  );
  return [{ type: 'full', amount: price, totalPrice: price }];
};
